<template>
  <a-breadcrumb-item>
    <router-link :to="{ name: bread.name }" v-if="bread.name != 'principal'">
      <a-icon class="icon" :type="bread.meta.icon" v-if="bread.meta.icon" style="color: #fff;" />
      <span style="color: #fff;">{{bread.meta.description}}</span>
    </router-link>
  </a-breadcrumb-item>
</template>

<script>
export default {
  name: 'breadcomponent',
  props: [
      'bread',
  ]
};
</script>

<style>
.icon {
  margin-right: 5px;
}

.ant-breadcrumb-separator {
  color: #fff;
}
</style>

